<template>
	<transition name="slide-fade">
		<div
			v-if="visible"
			class="mask"
			@click.self="$emit('close')"
		>
			<div
				class="app-popup"
				:class="{
					'app-popup--success' : isTypeSuccess,
					'app-popup--warning' : isTypeWarning,
					'app-popup--danger' : isTypeDanger
				}"
			>
				<p class="app-popup__title">
					{{ title }}
				</p>

				<p class="app-popup__message">
					{{ message }}
				</p>

				<div
					v-if="$slots.default"
					class="app-popup__buttons"
				>
					<slot></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		type: {
			validator (value) {
				return ['success', 'warning', 'danger'].includes(value)
			}
		},
		visible: Boolean,
		title: String,
		message: String
	},

	computed: {
		isTypeSuccess () {
			return this.type === 'success'
		},

		isTypeWarning () {
			return this.type === 'warning'
		},

		isTypeDanger () {
			return this.type === 'danger'
		}
	}
}
</script>

<style lang="scss" scoped>
.mask {
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff99;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	z-index: 999;
}

.app-popup {
	background-color: #fff;
	border-top: 5px solid #fff;
	box-shadow: 0 0 6px $default-light;
	color: $default-light;
	border-radius: 3px;
	font-size: 1.2em;
	margin: .5em;
	width: 22em;

	&__title,
	&__message {
		flex: 1 1 auto;
		text-align: center;
		padding: 2em 1em;
	}

	&__title {
		border-bottom: 2px solid #F8F9FB;
	}

	&__buttons {
		padding: 0 1em 2em 1em;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	&--success { border-color: $primary; }
	&--success &__title { color: $primary}

	&--warning { border-color: $warning; }
	&--warning &__title { color: $warning}

	&--danger { border-color: $danger; }
	&--danger &__title { color: $danger}
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all .5s ease;
  opacity: 1;
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
